import React from 'react';
import { Filter, Scale, Eye } from 'lucide-react';
import SectionHeading from './SectionHeading';

const POINTS = [
  {
    icon: Filter,
    title: 'One selection per tipster, per day.',
    text: 'Football markets contain thousands of possible selections every day. Each of our tipsters is allowed one release: a Double, a handicap line or a single. The ceiling is the point — it forces a choice instead of a list.'
  },
  {
    icon: Scale,
    title: 'Specialists, not generalists.',
    text: 'Turkish Team builds Doubles from goal and result markets. Asian Tips works only in Asian Handicap. 24 BOX Tips hunts a clean single near evens. Different formats, same discipline: research first, release second.'
  },
  {
    icon: Eye,
    title: 'Every day goes on the record.',
    text: 'Each tipster has a public archive with full-time scores, odds and results — including no-pick days. We would rather show the whole picture than a highlight reel.'
  }
];

export default function WhySection() {
  return (
    <section id="why" className="scroll-mt-24 py-24 md:py-32 bg-white" data-testid="why-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-5">
          <SectionHeading
            eyebrow="Why three specialists"
            title="We don't send more picks just to send more picks."
            lead="Three tipsters, three formats — and each one is capped at a single release per day. You pick the format that suits how you bet; the tipster does the narrowing."
          />
          <blockquote className="mt-10 border-l-[3px] border-royal pl-5 font-display text-xl md:text-2xl font-semibold text-navy leading-snug">
            Less noise. More selection.
          </blockquote>
        </div>

        <div className="lg:col-span-7 grid gap-4">
          {POINTS.map((p, i) => (
            <div
              key={p.title}
              className={`card-lift rounded-3xl border border-line bg-white p-7 md:p-8 flex gap-6 ${i === 1 ? 'lg:ml-12' : ''} ${i === 2 ? 'lg:ml-24' : ''}`}
              data-testid={`why-point-${i}`}
            >
              <div className="w-12 h-12 rounded-2xl bg-ice text-royal flex items-center justify-center flex-shrink-0">
                <p.icon className="w-5 h-5" strokeWidth={2.2} />
              </div>
              <div>
                <h3 className="font-display text-lg md:text-xl font-bold text-navy">{p.title}</h3>
                <p className="mt-2 text-sm md:text-[15px] text-slate-600 leading-relaxed">{p.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
